import { t } from "../i18n";
import { href, navigate } from "../lib/router";
import { usePlayer, usePlayerActions } from "../player/PlayerContext";
import { useHeroData } from "../state/heroData";
import { Avatar } from "./Avatar";
import { Icon } from "./Icon";

/**
 * Мини-плеер внизу на всех экранах, кроме «Плеера»: серия продолжает играть, пока
 * человек смотрит пейвол или аккаунт, и всегда видно, что звучит и как остановить.
 */
export function MiniPlayer() {
  const { hero } = useHeroData();
  const player = usePlayer();
  const actions = usePlayerActions();
  const track = player.track;
  if (!track) return null;

  const playing = player.status === "playing" || (player.status === "loading" && player.buffering);
  const share = player.duration > 0 ? Math.min(1, player.currentTime / player.duration) : 0;
  const subtitle = track.kind === "episode" ? t("episode.number", { n: track.ordinal }) : track.kind === "trailer" ? t("player.trailer") : hero.name;

  function open() {
    if (track?.kind === "episode") navigate(href.listen(track.ordinal));
    else navigate(href.listen());
  }

  return (
    <div className="mini-player" role="region" aria-label={track.title}>
      <span className="mini-player__progress" style={{ width: `${share * 100}%` }} aria-hidden="true" />
      <button type="button" className="mini-player__open" onClick={open}>
        <Avatar src={hero.theme.portraitUrl ?? hero.theme.coverUrl} name={hero.name} size={40} />
        <span className="mini-player__text">
          <span className="mini-player__title">{track.title}</span>
          <span className="mini-player__subtitle">{subtitle}</span>
        </span>
      </button>
      <button
        type="button"
        className="icon-btn icon-btn--accent"
        onClick={() => actions.toggle()}
        aria-label={playing ? t("player.pause") : t("player.play")}
      >
        <Icon name={playing ? "pause" : "play"} size={22} />
      </button>
    </div>
  );
}
